/*
  Carousel-Logik für den wiederverwendbaren TN-Stimmen-LinkedIn-Snippet
  (ui-linkedin-testimonial.liquid). Übernommen von collection-upskill-testimonial.js,
  erweitert auf mehrere Instanzen pro Seite.
*/
(function () {
  'use strict';

  document.querySelectorAll('.ui-linkedin-testimonial').forEach(function (section) {
    /* Doppel-Initialisierung verhindern, falls der Snippet mehrfach gerendert wird
       und das Script dadurch mehrfach ausgeführt wird */
    if (section.dataset.carouselInit) return;
    section.dataset.carouselInit = 'true';

    var prevBtn = section.querySelector('.ui-linkedin-testimonial__arrow--prev');
    var nextBtn = section.querySelector('.ui-linkedin-testimonial__arrow--next');
    var cards = section.querySelectorAll('.ui-linkedin-testimonial__card');
    if (!prevBtn || !nextBtn || !cards.length) return;

    var currentIndex = 0;
    var maxVisible = window.innerWidth <= 640 ? 1 : 2;

    for (var i = 0; i < maxVisible && i < cards.length; i++) {
      cards[i].style.display = 'flex';
    }

    prevBtn.addEventListener('click', function () {
      if (currentIndex > 0) {
        cards[currentIndex + maxVisible - 1].style.display = 'none';
        currentIndex--;
        cards[currentIndex].style.display = 'flex';
      }
    });

    nextBtn.addEventListener('click', function () {
      if (currentIndex < cards.length - maxVisible) {
        cards[currentIndex].style.display = 'none';
        currentIndex++;
        cards[currentIndex + maxVisible - 1].style.display = 'flex';
      }
    });
  });
})();
